<template>
	<div></div>
</template>

<script>
import { keycloak } from '../keycloak';
import { nextTick } from 'vue';

export default {
	name: 'LogOutPage',
	data() {
		return {
			isAuthenticated: false,
		};
	},
	methods: {
		handleLogout() {
			localStorage.removeItem('kcToken');
			localStorage.removeItem('kcRefreshToken');
			localStorage.removeItem('kcRetryCount');
			localStorage.removeItem('lang');
			keycloak
				.logout({
					redirectUri: window.location.origin,
					postLogoutRedirectUri: `${window.location.origin}`,
				})
				.then(() => {
					nextTick(() => {
						if (this.$route.path !== '/login') {
							this.$router.push('/login');
						}
					});
				})
				.catch((error) => {
					console.error('Logout failed:', error);
				});
		},
	},
	mounted() {
		this.isAuthenticated = keycloak.authenticated;
		if (this.isAuthenticated) {
			this.handleLogout();
		} else if (this.$route.path !== '/login') {
			this.$router.replace(`/login`);
		}
	},
};
</script>

<style>
button {
	margin-top: 10px;
}
</style>
